import { render, staticRenderFns } from "./ContactManageView.vue?vue&type=template&id=dd127aa2&scoped=true&"
import script from "./ContactManageView.vue?vue&type=script&lang=js&"
export * from "./ContactManageView.vue?vue&type=script&lang=js&"
import style0 from "./ContactManageView.vue?vue&type=style&index=0&id=dd127aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd127aa2",
  null
  
)

export default component.exports